import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, OnChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { BaseComponent } from '@uw/core/base.component';
import { AlertPageType, LoginAlert } from '@uw/core/enums/alert-pagetype.enum';
import { Alert } from '@uw/core/models/alert.model';
import { AlertService } from '@uw/core/services/alert.service';
import { MyErrorStateMatcher } from '../login-page/login-page.component';
import { ChangePasswordFormData } from '../../models';
import { PasswordRegistrationComponent } from '@uw/shared/components/password-registration/password-registration.component';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { PasswordComponent } from '../../../../shared/components/password/password.component';
import { MatError } from '@angular/material/input';
import { PasswordRegistrationComponent as PasswordRegistrationComponent_1 } from '../../../../shared/components/password-registration/password-registration.component';
import { NgStyle } from '@angular/common';
import { ButtonComponent } from '../../../../shared/components/button/button.component';

@Component({
    selector: 'app-change-password-form',
    templateUrl: './change-password-form.component.html',
    styleUrls: ['./change-password-form.component.scss'],
    imports: [ReactiveFormsModule, PasswordComponent, MatError, PasswordRegistrationComponent_1, NgStyle, ButtonComponent, TranslateModule]
})
export class ChangePasswordFormComponent
  extends BaseComponent
  implements OnInit, OnChanges
{
  @Input()
  buttonLoading: boolean = false;

  @Input()
  hideCurrentPassword: boolean = false;

  @Input()
  actionButtonLabel: string = 'button.update';

  @Output()
  changePassword = new EventEmitter<ChangePasswordFormData>();

  @ViewChild(PasswordRegistrationComponent)
  passwordRegistrationFormComponent!: PasswordRegistrationComponent;

  changePasswordFormGrp!: UntypedFormGroup;
  matcher = new MyErrorStateMatcher();

  alerts: Alert[] = [];
  passwordRequirementMessage: string;

  readonly currentLanguage = this.translateService.currentLang;

  constructor(
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    public translateService: TranslateService
  ) {
    super();
    //this.menuService.showDonarSubMenu(true);
    this.createForm();
  }

  ngOnInit(): void {
    this.alertService.fetchAlerts(AlertPageType.LOGIN).subscribe(
      (alerts) => {
        this.alerts = alerts;
        const alertMessage = this.alerts.find(
          (al) => al.name == LoginAlert.STRONG_PASSWORD_MESSAGE
        );
        if (alertMessage) {
          this.passwordRequirementMessage =
            this.currentLanguage == 'en'
              ? alertMessage.contentXML
              : alertMessage.contentXML_fr;
        } else {
          this.passwordRequirementMessage = this.translateService.instant(
            'change_password.pwd_requirements_msg'
          );
        }
      },
      () => {
        this.alerts = [];
      }
    );
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (
      simpleChanges &&
      simpleChanges.hideCurrentPassword &&
      simpleChanges.hideCurrentPassword.currentValue
    ) {
      this.changePasswordFormGrp &&
        this.changePasswordFormGrp.removeControl('currentPassword');
    }
  }

  createForm() {
    this.changePasswordFormGrp = this.fb.group(
      {
        currentPassword: [null, [Validators.required]],
        passwordRegistration: this.fb.control(null),
      }
    );
  }

  onChangePassword(): void {
    this.markAllAsTouched(this.changePasswordFormGrp);
    if (this.changePasswordFormGrp.valid) {
      const { currentPassword, passwordRegistration } =
        this.changePasswordFormGrp.value;

      const { password: newPassword, confirmPassword } = passwordRegistration;

      const payload = { currentPassword, newPassword, confirmPassword };

      this.changePassword.emit(payload);
    }
  }

  private markAllAsTouched(formGroup: UntypedFormGroup) {
    formGroup.markAllAsTouched();

    // Explicitly mark child form controls as touched
    if (this.passwordRegistrationFormComponent) {
      this.passwordRegistrationFormComponent.markAllControlsAsTouched();
    }
  }

  showPassword(passwordControl: HTMLInputElement) {
    if (passwordControl.type === 'password') {
      passwordControl.type = 'text';
    } else {
      passwordControl.type = 'password';
    }
  }
}
